import styled from 'styled-components';

import { useCurrentUser } from '@/store/currentUser';
import { toHtml } from '@/component/customEditor/logic/serialization';
import { TextStyled } from './styles';
import { RUserLearningSubmissionReview } from '@/store/v2';
import { SubmittedReviews } from '@/administration/pages/Course/pages/assessments/common/reviews/PeersToReview/SubmittedReviews';
import { AuthorHeader } from '@/administration/pages/Course/pages/assessments/common/AuthorHeader';
import { Divider } from '@/administration/pages/Course/pages/assessments/common/Divider';

const RootStyled = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.neutral.outline1};
  padding: 32px;
  gap: 32px;
  border-radius: 8px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const SubmissionResult = ({
  submissionText,
  createdAt,
  receivedReviews,
  peerReviewEnabled,
}: {
  submissionText: string;
  createdAt: string;
  receivedReviews: RUserLearningSubmissionReview[];
  peerReviewEnabled: boolean;
}): JSX.Element => {
  const { user } = useCurrentUser();

  return (
    <RootStyled>
      <AuthorHeader authorId={user?.id} createdAt={createdAt} />
      <TextStyled className="content is-article" dangerouslySetInnerHTML={{ __html: toHtml(submissionText) }}></TextStyled>
      {peerReviewEnabled && (
        <>
          <Divider />
          <div>
            <SubmittedReviews reviews={receivedReviews} />
          </div>
        </>
      )}
    </RootStyled>
  );
};
